import { useState } from 'react'
import { useRouter } from 'next/router'

import { Text } from '@wartek-id/text-v1'
import { Button } from '@wartek-id/button-v1'
import { Separator } from '@wartek-id/separator'
import { Spinner } from '@wartek-id/spinner'
import { useToast } from '@wartek-id/toast'

import DialogKonfirmasi from './DialogKonfirmasi'
import { PENGELOLAAN_KINERJA_GURU_PATH } from 'app/KinerjaShared/constants/path'
import {
  useAPIGetUnorData,
  useAPIPatchConfirmUnor,
} from 'api/kinerja/useAPIKinerja'
import { UnorAtasanCard, UnorSatuanPendidikanCard } from './UnorCard'

import type { KonfirmasiUnorStatus } from 'types/kinerja'

export default function KonfirmasiUnorPage() {
  const toast = useToast()
  const router = useRouter()
  const [isDialogOpen, setIsDialogOpen] = useState(false)

  const [isSatuanPendidikanIndukCorrect, setIsSatuanPendidikanIndukCorrect] =
    useState<string | null>(null)
  const [isAtasanCorrect, setIsAtasanCorrect] = useState<string | null>(null)

  const { data: { data } = {}, isLoading } = useAPIGetUnorData()
  const { mutateAsync } = useAPIPatchConfirmUnor()

  const isNextButtonDisable =
    isSatuanPendidikanIndukCorrect === null || !isAtasanCorrect === null

  let statusUnor: KonfirmasiUnorStatus = 'NOT_SUBMITTED'

  if (isSatuanPendidikanIndukCorrect === 'true' && isAtasanCorrect === 'true') {
    statusUnor = 'UNOR_MATCH'
  } else if (
    isSatuanPendidikanIndukCorrect === 'false' &&
    isAtasanCorrect === 'false'
  ) {
    statusUnor = 'UNOR_UNMATCH'
  } else {
    if (isSatuanPendidikanIndukCorrect === 'false') {
      statusUnor = 'UNOR_UNMATCH_ORG'
    } else {
      statusUnor = 'UNOR_UNMATCH_SUPERIOR'
    }
  }

  const onConfirm = async () => {
    try {
      await mutateAsync({
        statusUnor,
      })

      toast({
        type: 'success',
        message: 'Berhasil konfirmasi data!',
      })

      router.push(PENGELOLAAN_KINERJA_GURU_PATH)
    } catch (e) {
      toast({
        message: 'Gagal konfirmasi data. Coba lagi.',
      })
    }
  }

  return (
    <div className="py-16">
      {isLoading ? (
        <div className="m-auto">
          <Spinner data-testid="loading-spinner" />
        </div>
      ) : (
        <>
          <div className="mx-[128px] bg-white rounded-lg flex flex-col">
            <div className="flex flex-col gap-6 p-6">
              <header className="flex flex-col gap-[6px]">
                <Text variant="display-sm">Konfirmasi data Anda</Text>
                <Text color="subdued">
                  Data di bawah kami peroleh dari E-Kinerja. Mohon konfirmasi
                  kebenaran data.
                </Text>
              </header>

              <UnorSatuanPendidikanCard
                data={data}
                isSatuanPendidikanIndukCorrect={isSatuanPendidikanIndukCorrect}
                onSatuanPendidikanIndukChanged={(value) =>
                  setIsSatuanPendidikanIndukCorrect(value)
                }
              />

              <UnorAtasanCard
                data={data}
                isAtasanCorrect={isAtasanCorrect}
                onAtasanChanged={(value) => setIsAtasanCorrect(value)}
              />
            </div>
            <Separator />
            <div className="flex p-4">
              <Button
                className="ml-auto"
                disabled={isNextButtonDisable}
                size="lg"
                onClick={() => {
                  setIsDialogOpen(true)
                }}
              >
                Lanjut
              </Button>
            </div>
          </div>

          <DialogKonfirmasi
            data-testid="dialog-konfirmasi"
            data={data}
            isOpen={isDialogOpen}
            onClose={() => setIsDialogOpen(false)}
            isSatuanPendidikanIndukCorrect={isSatuanPendidikanIndukCorrect}
            isAtasanCorrect={isAtasanCorrect}
            onConfirm={onConfirm}
          />
        </>
      )}
    </div>
  )
}
